<template>
  <section id="showcase" class="showcase">
    <div class="container">
      <div class="preview">
        <div class="gallery">
          <img class="shot" src="../images/watch-1.png" alt="表盘示例">
          <img class="shot" src="../images/watch-2.png" alt="通知示例">
          <img class="shot" src="../images/watch-3.png" alt="应用界面">
        </div>
      </div>
      <div class="copy">
        <h2>腕上体验 · 毫秒响应</h2>
        <p>针对表盘、通知与快捷卡片的交互设计，60fps 动效与电量友好并存，复杂场景依旧稳定顺滑。</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Showcase'
}
</script>

<style scoped>
.showcase {
  padding: 64px 16px;
  background: #0f172a;
  color: #e5e7eb;
}
.container {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: center;
}
.gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.shot {
  width: 100%;
  aspect-ratio: 9 / 16;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #0b1020;
}
@media (max-width: 900px) {
  .container {
    grid-template-columns: 1fr;
  }
}
</style>


